export const MSE_PRODUCT = [
  'TECHQA',
  'FORMULATION_LEGACY',
  'FORMULATION',
  'FIND_SOLUTIONS',
  'SMART_SEARCH',
  'QUICK_RESEARCH',
  'DFMEA_ASSISTANT',
  'DOC_ANALYZER',
  'INVENTION_DISCLOSURE',
  'IDEA_VALIDATION',
  'TECHNOLGY_ROADMAP',
] as const;

export const SEARCH_TYPES = [
  'ADVANCED',
  'SUBSTANCE_INQUIRY',
  'STRUCTURE_SEARCH',
  'SYNTH_SEARCH',
  'PROFILE_SEARCH',
  'COMPOSITION_SEARCH',
] as const;

export type ClassicalSearches = (typeof SEARCH_TYPES)[number];
export type MseProduct = (typeof MSE_PRODUCT)[number];

// maps old product key to new product frontend key
export const productKeyMap: Record<string, MseProduct> = {
  mse_material_tech_qa: 'TECHQA',
  novelty_check: 'IDEA_VALIDATION',
  ai_patent_disclosure: 'INVENTION_DISCLOSURE',
  research: 'QUICK_RESEARCH',
  fmea: 'DFMEA_ASSISTANT',
  mse_doc_analyzer: 'DOC_ANALYZER',
  find_solution_material_v2: 'FIND_SOLUTIONS',
  mse_playbook_full_dimensional_search: 'SMART_SEARCH',
  material_formulation_v4_package: 'FORMULATION',
  material_formulation_package: 'FORMULATION_LEGACY',
  roadmap: 'TECHNOLGY_ROADMAP',
};

// maps old product key to new search frontend key
export const searchKeyMap: Record<string, ClassicalSearches> = {
  mse_playbook_full_dimensional_search: 'ADVANCED',
  substance_search: 'SUBSTANCE_INQUIRY',
  structure_search: 'STRUCTURE_SEARCH',
  workflow_search: 'SYNTH_SEARCH',
  property_search: 'PROFILE_SEARCH',
  metal_search: 'COMPOSITION_SEARCH',
};
